import { render, staticRenderFns } from "./v-confirm.vue?vue&type=template&id=5e72e5b2&scoped=true&"
import script from "./v-confirm.vue?vue&type=script&lang=js&"
export * from "./v-confirm.vue?vue&type=script&lang=js&"
import style0 from "./v-confirm.vue?vue&type=style&index=0&id=5e72e5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72e5b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VSpacer,VToolbar})
